function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var ALL_PLACEMENTS = 'All Placements';
export var ALL_APPS = 'All Apps';
export var ALL_COUNTRIES = 'All Countries';
export var COPY_IDENTIFIER_LABEL = 'Click identifier to copy';
export var DASHBOARD = 'Dashboard';
export var PLATFORM_IOS = 0;
export var PLATFORM_ANDROID = 1;
export var PLATFORM_JS = 2;
export var PLATFORM_IFRAME = 3;
export var PLATFORM_API = 4;
export var SPAN_BACK_DAYS = 7;
export var CREATE_APP = 'Create App';
export var EDIT_APP_HEADING = 'Edit App';
export var CONFIRM = 'Save';
export var ADD_OFFER = 'Add';
export var OFFER_HEADER = 'Placements';
export var OFFER_NAME = 'Placement Placeholder 1';
export var OFFER_IDENTIFIER = 'Identifier';
export var OFFER_DESCRIPTION = 'Description';
export var OFFER_LIMIT = 5;
export var OFFER_LIMIT_REACHED = 'You have reached the max offer limit for this app. Please contact TapResearch for further assistance.';
export var ADD_CURRENCY_SALE = 'Add Currency Sale';
export var REMOVE_CURRENCY_SALE = 'Remove Currency Sale';
export var CURRENCY_SALE_HEADER = 'Currency Sales';
export var OVERVIEW = 'Overview';
export var REPORTS_HEADING_AMOUNT = 'Amount';
export var REPORTS_HEADING_MONTH = 'Month (UTC timezone)';
export var REVENUE = 'Revenue';
export var RECONCILED_REVENUE = 'Reconciled Revenue';
export var TRANSACTIONS = 'Transactions';
export var UNAVAILABLE = 'Not available';
export var VALIDATE_APP_NAME_IS_EMPTY = 'App name cannot be blank.';
export var VALIDATE_APP_NAME_MEETS_MIN_LENGTH = 'App name must be at least two characters.';
export var VALIDATE_SURVEY_CURRENCY_NAME = 'Currency name cannot be empty.';
export var VALIDATE_SURVEY_EXCHANGE_RATE = 'Exchange rate must be greater than zero.';
export var VALIDATE_PROFILE_EXCHANGE_RATE = 'Exchange rate must be greater than zero.';
export var VALIDATE_APP_COLOR_INVALID = 'App color must be in format #000 or #000000.';
export var CALLBACK = 'Callback';
export var CALLBACK_SUCCESS = 'Callback Successful';
export var CALLBACK_FAIL = 'Callback failed';
export var CALLBACK_URL = 'Callback URL';
export var TEST_CALLBACK = 'Test Callback';
export var SUPPLIER_STATUS_SIGNUP = 0;
export var SUPPLIER_STATUS_UNQUALIFIED = 1;
export var SUPPLIER_STATUS_ACTIVE = 2;
export var SUPPLIER_STATUS_SUSPENDED = 3;
export var SUPPLIER_USER_DISABLED = 4;
export var SUPPLIER_TYPE_GPT = 1;
export var GENERIC_ERROR = 'Sorry! Something went wrong. Please try again.';
export var QUALIFICATION_DESIGNATION_TYPE_DEFAULT = 0;
export var QUALIFICATION_DESIGNATION_TYPE_CUSTOM = 5;
export var DOLLAR_SYMBOL = '$';
export var CENTS = 'cents';
export var CURRENCY_SALE_STATUS_UPCOMING = 0;
export var CURRENCY_SALE_STATUS_LIVE = 1;
export var CURRENCY_SALE_STATUS_EXPIRING = 2;
export var CURRENCY_SALE_STATUS_EXPIRED = 3;
export var CURRENCY_SALE_STATUS_DELETED = 4;
export var APP_TITLE_BOOST_TYPE_CUSTOM = 0;
export var APP_TITLE_BOOST_TYPE_BIRTHDAY = 1;
export var APP_TITLE_BOOST_TYPE_INACTIVITY = 2;
export var APP_TITLE_BOOST_TYPE_NEW_USER = 3;
export var ORGANIZATION_ROLE_ADMIN = 1;
export var ORGANIZATION_ROLE_USER = 2;
export var ORGANIZATION_ROLE_CUSTOMER_SUCCESS = 3;
export var PLACEMENT_TYPE_MANUAL = 0;
export var PLACEMENT_TYPE_AUTOMATIC = 1;
export var PLACEMENT_TYPE_UNPUBLISHED = 2;
export var APP_TITLE_COHORT_FILTER_OPERATOR_EQL = 0;
export var APP_TITLE_COHORT_FILTER_OPERATOR_GTE = 1;
export var APP_TITLE_COHORT_FILTER_OPERATOR_LTE = 2;
export var APP_TITLE_COHORT_FILTER_OPERATOR_CONTAINS = 3;
export var APP_TITLE_COHORT_FILTER_OPERATOR_NOT_EQL = 4;
export var NEW_UPLOAD_ATTRIBUTE = '__NEW_UPLOAD_ATTRIBUTE__';
export var ALL_OPERATORS = [
    APP_TITLE_COHORT_FILTER_OPERATOR_EQL,
    APP_TITLE_COHORT_FILTER_OPERATOR_GTE,
    APP_TITLE_COHORT_FILTER_OPERATOR_LTE,
    APP_TITLE_COHORT_FILTER_OPERATOR_CONTAINS,
    APP_TITLE_COHORT_FILTER_OPERATOR_NOT_EQL
];
export var QQ_SURVEY_QUESTION_TYPE_MC = 0;
export var QQ_SURVEY_QUESTION_TYPE_RATING = 1;
export var QQ_SURVEY_QUESTION_TYPE_BOOL = 2;
export var QQ_SURVEY_QUESTION_TYPE_OPEN_TEXT = 3;
export var QQ_ANSWER_TYPE_MC_NORMAL = 0;
export var QQ_ANSWER_TYPE_MC_NONE = 1;
export var QQ_ANSWER_TYPE_RATING = 2;
export var QQ_ANSWER_TYPE_BOOL_YES = 3;
export var QQ_ANSWER_TYPE_BOOL_NO = 4;
export var QQ_SURVEY_STATUS_DRAFT = 0;
export var QQ_SURVEY_STATUS_ACTIVE = 1;
export var QQ_SURVEY_STATUS_PAUSED = 2;
export var QQ_SURVEY_STATUS_COMPLETE = 3;
export var QQ_SURVEY_STATUS_ARCHIVED = 4;
export var IMAGEABLE_USAGE_BANNER = 0;
export var IMAGEABLE_USAGE_BACKGROUND = 1;
export var IMAGEABLE_USAGE_INTERSTITIAL_FULL_SCREEN = 2;
export var IMAGEABLE_USAGE_ICON = 3;
export var IMAGE_RATIO_3_4 = '3:4';
export var IMAGE_RATIO_9_16 = '9:16';
export var IMAGE_RATIO_9_19 = '9:19';
export var IMAGE_RATIO_9_21 = '9:21';
export var SCHEDULED_EVENT_INTERVAL_TYPE_RRULE = 0;
export var SCHEDULED_EVENT_INTERVAL_TYPE_CUSTOM = 1;
export var SURVEY_WALL_TYPE_DEFAULT = 0;
export var SURVEY_WALL_TYPE_SPOTLIGHT = 1;
export var OFFER_PLACEMENT_TYPE_DEFAULT = 0;
export var OFFER_PLACEMENT_TYPE_INTERSTITIAL = 1;
export var OFFER_PLACEMENT_TYPE_INTERSTITIAL_PARTIAL = 2;
export var OFFER_PLACEMENT_TYPE_BANNER = 3;
export var OFFER_PLACEMENT_TYPE_QQ_SURVEY = 4;
export var OFFER_PLACEMENT_TYPE_WALL_PREVIEW = 5;
export var OFFER_PLACEMENT_TYPE_SPOTLIGHT = 6;
export var OFFERABLE_PLACEMENT_TYPE_MAP = Object.freeze({
    OfferTypeButton: OFFER_PLACEMENT_TYPE_DEFAULT,
    OfferTypeInterstitial: OFFER_PLACEMENT_TYPE_INTERSTITIAL_PARTIAL,
    OfferTypeBanner: OFFER_PLACEMENT_TYPE_BANNER,
    OfferTypeSurvey: OFFER_PLACEMENT_TYPE_QQ_SURVEY,
    OfferTypeWallPreview: OFFER_PLACEMENT_TYPE_WALL_PREVIEW
});
var _obj;
export var QQ_SURVEY_STATUS_TEXT = Object.freeze((_obj = {}, _define_property(_obj, QQ_SURVEY_STATUS_DRAFT, 'Draft'), _define_property(_obj, QQ_SURVEY_STATUS_ACTIVE, 'In-progress'), _define_property(_obj, QQ_SURVEY_STATUS_PAUSED, 'Paused'), _define_property(_obj, QQ_SURVEY_STATUS_COMPLETE, 'Complete'), _define_property(_obj, QQ_SURVEY_STATUS_ARCHIVED, 'Archived'), _obj));
var _obj1;
export var IMAGE_DIMENSIONS_BY_RATIO = Object.freeze((_obj1 = {}, _define_property(_obj1, IMAGE_RATIO_3_4, {
    width: 360,
    height: 480,
    ratio: '3 / 4',
    ratio_landscape: '4 / 3'
}), _define_property(_obj1, IMAGE_RATIO_9_16, {
    width: 360,
    height: 640,
    ratio: '9 / 16',
    ratio_landscape: '16 / 9'
}), _define_property(_obj1, IMAGE_RATIO_9_19, {
    width: 315,
    height: 665,
    ratio: '9 / 19',
    ratio_landscape: '19 / 9'
}), _define_property(_obj1, IMAGE_RATIO_9_21, {
    width: 300,
    height: 700,
    ratio: '9 / 21',
    ratio_landscape: '21 / 9'
}), _obj1));
export var MANUAL_OFFERABLE_TYPES = [
    'OfferTypeButton',
    'OfferTypeWallPreview'
];
export var OFFERABLE_LABELS = Object.freeze({
    OfferTypeInterstitial: 'Interstitials',
    OfferTypeBanner: 'Banners',
    OfferTypeButton: 'Survey wall buttons',
    OfferTypeSurvey: 'Quick questions',
    OfferTypeWallPreview: 'Wall previews'
});
var _obj2;
export var OfferPlacementType = Object.freeze((_obj2 = {}, _define_property(_obj2, 0, 'Default'), _define_property(_obj2, 1, 'Fullscreen'), _define_property(_obj2, 2, 'Floating Interstitial'), _define_property(_obj2, 3, 'Banner'), _obj2));
var _obj3;
export var PlacementType = Object.freeze((_obj3 = {}, _define_property(_obj3, PLACEMENT_TYPE_MANUAL, 'Survey wall'), _define_property(_obj3, PLACEMENT_TYPE_AUTOMATIC, 'Pop-up'), _define_property(_obj3, PLACEMENT_TYPE_UNPUBLISHED, 'Not published'), _obj3));
var _obj4;
export var PlatformType = Object.freeze((_obj4 = {}, _define_property(_obj4, PLATFORM_IOS, 'iOS'), _define_property(_obj4, PLATFORM_ANDROID, 'Android'), _define_property(_obj4, PLATFORM_JS, 'Javascript'), _define_property(_obj4, PLATFORM_IFRAME, 'Iframe'), _define_property(_obj4, PLATFORM_API, 'API'), _obj4));
var _obj5;
export var CreatePlatformType = Object.freeze((_obj5 = {}, _define_property(_obj5, PLATFORM_IOS, 'iOS'), _define_property(_obj5, PLATFORM_ANDROID, 'Android'), _obj5));
export var APP_STATUS_TEST = 0;
export var APP_STATUS_SOFT_LAUNCH = 1;
export var APP_STATUS_LIVE = 2;
var _obj6;
export var AppStatusType = Object.freeze((_obj6 = {}, _define_property(_obj6, APP_STATUS_TEST, 'Testing'), _define_property(_obj6, APP_STATUS_SOFT_LAUNCH, 'Live'), _define_property(_obj6, APP_STATUS_LIVE, 'Live'), _obj6));
export var PAYOUT_EVENT_PROFILE_COMPLETE = 0;
export var PAYOUT_EVENT_CAMPAIGN_COMPLETE = 3;
var _obj7;
export var PayoutEventType = Object.freeze((_obj7 = {}, _define_property(_obj7, PAYOUT_EVENT_CAMPAIGN_COMPLETE, 'Survey Complete'), _define_property(_obj7, PAYOUT_EVENT_PROFILE_COMPLETE, 'Profile Complete'), _obj7));
export var PayoutEventDescription = Object.freeze(_define_property({}, PAYOUT_EVENT_PROFILE_COMPLETE, 'Optional setting that gives the user a reward for completing their profile. This typically increases initial engagement and user lifetime value. This amount is not subsidized by TapResearch.'));
export var RewardAmountSubtitle = Object.freeze(_define_property({}, PAYOUT_EVENT_CAMPAIGN_COMPLETE, 'The amount of app currency the user would receive for (USD) $1.00 IAP'));
var _obj8;
export var DevPlatforms = Object.freeze((_obj8 = {}, _define_property(_obj8, 'ios', 'iOS'), _define_property(_obj8, 'android', 'Android'), _define_property(_obj8, 'unity', 'Unity'), _define_property(_obj8, 'react', 'React'), _define_property(_obj8, 'flutter', 'Flutter'), _obj8));
var _obj9;
export var VersionStatus = Object.freeze((_obj9 = {}, _define_property(_obj9, 0, 'Latest'), _define_property(_obj9, 1, 'Outdated'), _define_property(_obj9, 2, 'Deprecated'), _define_property(_obj9, 3, 'Unsupported'), _obj9));
export var DocumentationLinks = Object.freeze([
    {
        tag: 'ios',
        url: 'https://supply-docs.tapresearch.com/docs/3.x/basic-integration/sdk-integration/ios',
        name: 'iOS Integration Guide'
    },
    {
        tag: 'android',
        url: 'https://supply-docs.tapresearch.com/docs/3.x/basic-integration/sdk-integration/android',
        name: 'Android Integration Guide'
    },
    {
        tag: 'unity',
        url: 'https://supply-docs.tapresearch.com/docs/3.x/basic-integration/sdk-integration/unity',
        name: 'Unity Integration Guide'
    },
    {
        tag: 'react',
        url: 'https://supply-docs.tapresearch.com/docs/3.x/basic-integration/sdk-integration/react-native',
        name: 'React Native Integration Guide'
    },
    {
        tag: 'callbacks',
        url: 'https://supply-docs.tapresearch.com/docs/3.x/basic-integration/sdk-integration/callbacks',
        name: 'Survey Complete Callbacks'
    }
]);
export var DocumentationLinksMap = DocumentationLinks.reduce(function(map, obj) {
    map[obj.tag] = obj;
    return map;
}, {});
